"use client";

import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { Wifi, WifiOff } from "lucide-react";
import useNetworkStatus from "@/hooks/useNetworkStatus";

const OFFLINE_TOAST_ID = "network-status-offline";
const ONLINE_TOAST_ID = "network-status-online";

// closeButton, not a hand-rolled button in `action`: sonner renders the action
// slot as a flex child, so a 28px icon button got squeezed next to the text and
// still had to round-trip through the toast store to dismiss. The built-in one
// is pinned to the corner and closes the toast it sits on directly.
const notifyOffline = () =>
  toast.error("Koneksi internet terputus", {
    id: OFFLINE_TOAST_ID,
    description:
      "Periksa kembali koneksi internet Anda. Beberapa fitur mungkin tidak berfungsi.",
    icon: <WifiOff />,
    duration: Infinity,
    closeButton: true,
  });

const notifyBackOnline = () =>
  toast.success("Kembali online", {
    id: ONLINE_TOAST_ID,
    description: "Koneksi internet Anda sudah pulih kembali.",
    icon: <Wifi />,
    duration: 5000,
    closeButton: true,
  });

const NetworkStatusToast = () => {
  const { isOnline } = useNetworkStatus();
  const prevIsOnlineRef = useRef(isOnline);
  const isFirstRunRef = useRef(true);

  useEffect(() => {
    if (isFirstRunRef.current) {
      isFirstRunRef.current = false;
      if (!navigator.onLine) {
        prevIsOnlineRef.current = false;
        notifyOffline();
      }
      return;
    }

    if (prevIsOnlineRef.current === isOnline) return;

    prevIsOnlineRef.current = isOnline;
    if (isOnline) {
      notifyBackOnline();
    } else {
      notifyOffline();
    }
  }, [isOnline]);

  return null;
};

export default NetworkStatusToast;
